exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-autocomplete {\n  margin-right: 15px;\n  margin-left: -3px; }\n\n.chip-notValid {\n  background-color: #E55049;\n  color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/colaborador-autocomplete/colaborador-autocomplete.component.scss
// module id = ../../../../../src/app/components/common/autocomplete/colaborador-autocomplete/colaborador-autocomplete.component.scss
// module chunks = 0